/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IOrderRequestlinesTemplateData } from './order-requestlines-template.data';
import { IOrderRequestlinesTemplateProps } from './order-requestlines-template.props.autogenerated';
import { getRequestOrderAsync, updateRequestOrderAsync } from '../../dataActions/DataActionExtension.g';
import {
    FullProductInput,
    getFallbackImageUrl,
    getFullProducts,
    getProductDetailsCriteriaFromActionInput
} from '@msdyn365-commerce-modules/retail-actions';
import { addCartLinesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { Button } from '@msdyn365-commerce-modules/utilities';

import { getCartState } from '@msdyn365-commerce/global-state';
import { reaction } from 'mobx';

export interface IOrderRequestlinesTemplateViewProps extends IOrderRequestlinesTemplateProps<IOrderRequestlinesTemplateData> {
    requestOrderLines: [];
    currentPageItems: [];
    headers: [];
    removeOrderRequestLine: any;
    addItemToCart: any;
    toasterInfo: any;
    removePopUp: any;
    _renderPopUp?: any;
    _togglePopUp?: any;
    totalItemPerPage: number;
    activePage: number;
    pageCount: number;
    handlePageItemsChange: any;
    handleMouseEnterEvent: any;
    handleMouseOutEvent: any;
    mouseOverIndex: number;
    handleOnChangeInput: any;
    searchItems: any;
    resetItems: any;
    searchString: string;
    searchPageItems: [];
    isLoading: boolean;
    getOrderDetailPageUrl: any;
}
export interface IOrderRequestlinesTemplateState {
    requestOrderLines: [];
    currentPageItems: [];
    headers: any;
    customerInfo: { AccountNumber: '' };
    products: [];
    toasterInfo: {};
    removePopUp: { visible: false };
    totalItemPerPage: number;
    activePage: number;
    pageCount: number;
    mouseOverIndex: number;
    searchString: string;
    searchPageItems: [];
    cart: any;
    isLoading: boolean;
}

/**
 *
 * OrderRequestlinesTemplate component
 * @extends {React.PureComponent<IOrderRequestlinesTemplateProps<IOrderRequestlinesTemplateData>>}
 */
class OrderRequestlinesTemplate extends React.Component<
    IOrderRequestlinesTemplateProps<IOrderRequestlinesTemplateData>,
    IOrderRequestlinesTemplateState
> {
    // private cart: any;
    private selectedLine: any;
    constructor(props: any) {
        super(props);
        this.state = {
            requestOrderLines: [],
            currentPageItems: [],
            headers: ['Customer', 'Phone', 'Email', 'Order Number', 'Created Date', 'Total Price', 'Snapshot ID', 'Actions'],
            customerInfo: { AccountNumber: '' },
            products: [],
            toasterInfo: { visible: false },
            removePopUp: { visible: false },
            totalItemPerPage: this.props.config.totalItemPerPage ? this.props.config.totalItemPerPage : 0,
            activePage: 1,
            pageCount: 0,
            mouseOverIndex: 0,
            searchString: '',
            searchPageItems: [],
            cart: undefined,
            isLoading: true
        };
    }
    public async componentDidMount(): Promise<void> {
        reaction(
            () => this.props.data.cart.result?.cart,
            async () => {
                if (this.props.data.cart.result?.cart) {
                    const cart: any = this.props.data.cart.result?.cart;
                    console.log('cart', cart);
                    const customerInfo = this.props.data.customerInformation.result;
                    await this.getRequestOrderList(customerInfo, cart);
                    this.setState({ cart: cart });
                }
            }
        );
    }

    public getRequestOrderList = async (customerInfo: any, cart: any) => {
        const response: any = await getRequestOrderAsync({ callerContext: this.props.context.actionContext, queryResultSettings: {} }, '');

        if (response.RequestOrder) {
            const productInputs: any = [];
            response.RequestOrder.map((requestOrder: any) => {
                if (requestOrder.ProductId) {
                    productInputs.push(
                        new FullProductInput(
                            requestOrder.ProductId,
                            this.props.context.actionContext.requestContext.apiSettings,
                            getProductDetailsCriteriaFromActionInput(this.props.context.actionContext)
                        )
                    );
                }
            });
            if (productInputs.length > 0) {
                return getFullProducts(productInputs, this.props.context.actionContext).then(async products => {
                    if (products) {
                        this.mappedRequestOrder(response.RequestOrder, products, customerInfo, cart);
                    } else {
                        this.setState({ requestOrderLines: [], customerInfo: customerInfo, products: [], isLoading: false });
                    }
                });
            } else {
                this.setState({ requestOrderLines: [], customerInfo: customerInfo, products: [], isLoading: false });
            }
        }
    };
    private getOrderDetailPageUrl = (requestId: string, lineNum: number) => {
        const request = this.props.context.request;
        let orderDetailUrl = request.url.requestUrl.origin;
        if (request.sitePath) {
            orderDetailUrl = orderDetailUrl + request.sitePath;
        }
        if (requestId && request) {
            return `${orderDetailUrl}${this.props.config.redirectToOrderDetailUrl}?requestOrderId=${requestId}&lineNum=${lineNum}`;
        }
        return '';
    };
    public mappedRequestOrder(requestOrders: any, products: any, customerInfo: any, cart: any) {
        const mappedProducts: any = [];
        for (const requestOrder of requestOrders) {
            if (requestOrder.RequestOrderId) {
                const product: any = products.find((p: any) => {
                    return requestOrder.ProductId === p.ProductDetails.RecordId;
                });
                if (product && requestOrder.ProductId) {
                    // disable actions for existing cartline...
                    let matchedCartProducts = [];
                    if (cart) {
                        matchedCartProducts = cart.CartLines.filter((cartLine: any) => {
                            return requestOrder.ProductId === cartLine.ProductId;
                        });
                        requestOrder.orderExistInCart = matchedCartProducts.some((p: any) => {
                            let requestOrderId = '';
                            let lineId = null;
                            let snapShotId = '';
                            if (p.ExtensionProperties.length > 0) {
                                p.ExtensionProperties.forEach((e: any) => {
                                    if (e.Key === 'AAA_REQUESTORDERID') {
                                        requestOrderId = e.Value.StringValue;
                                    }
                                    if (e.Key === 'AAA_REQUESTORDERLINENUM') {
                                        lineId = e.Value.DecimalValue;
                                    }
                                    if (e.Key === 'AAA_SNAPSHOTID') {
                                        snapShotId = e.Value.StringValue;
                                    }
                                });
                            }

                            return (
                                requestOrder.RequestOrderId === requestOrderId &&
                                requestOrder.Snapshotid === snapShotId &&
                                requestOrder.LineNum === lineId
                            );
                        });
                    }
                    if (matchedCartProducts.length === 0) {
                        requestOrder.orderExistInCart = false;
                    }

                    if (requestOrder.Snapshotid) {
                        const bmaImageWithFormatEndPoint = this.props.app.config.bmaImageWithFormatEndPoint.replace(
                            '#snapshotId',
                            requestOrder.Snapshotid
                        );
                        requestOrder.imageUrl = `${this.props.app.config.bmaBaseUrl}${bmaImageWithFormatEndPoint}`;
                    } else {
                        const fallbackImage = getFallbackImageUrl(
                            product.ProductDetails.ItemId,
                            this.props.context.actionContext.requestContext.apiSettings
                        );
                        requestOrder.imageUrl = product.ProductDetails.PrimaryImageUrl;
                        requestOrder.fallbackImage = fallbackImage;
                    }
                    requestOrder.product = { ...product };
                    const productPrice = { ...product.ProductPrice };
                    productPrice.AdjustedPrice = requestOrder.B2CPrice;
                    productPrice.BasePrice = requestOrder.B2CPrice;
                    productPrice.CustomerContextualPrice = requestOrder.B2CPrice;
                    productPrice.TradeAgreementPrice = requestOrder.B2CPrice;
                    requestOrder.productPrice = productPrice;
                    mappedProducts.push(requestOrder);
                }
            }
        }
        // if manage orders length > 0 set active 1 per page 5,
        // divided mangage orders / per page 50/5=10 pagaes
        // if active is 1 page pick  0 to active -1 and push into cureent page items
        const currentPageItems = this.currentPageItems(this.state.activePage, this.state.totalItemPerPage, mappedProducts);
        this.setState({
            requestOrderLines: mappedProducts,
            customerInfo: customerInfo,
            products: products,
            currentPageItems: currentPageItems,
            isLoading: false,
            pageCount:
                mappedProducts.length <= this.state.totalItemPerPage ? 1 : Math.ceil(mappedProducts.length / this.state.totalItemPerPage)
        });
    }
    private handleMouseEnterEvent = (index: number) => {
        this.setState({ mouseOverIndex: index });
    };
    private handleMouseOutEvent = () => {
        this.setState({ mouseOverIndex: 0 });
    };
    private handlePageItemsChange = (totalItemPerPage: any, activePage: number) => {
        let pageCount: number;
        let currentPageItems: any;
        if (this.state.searchPageItems.length > 0) {
            pageCount =
                this.state.searchPageItems.length <= totalItemPerPage ? 1 : Math.ceil(this.state.searchPageItems.length / totalItemPerPage);
            currentPageItems = this.currentPageItems(activePage, totalItemPerPage, this.state.searchPageItems);
        } else {
            pageCount =
                this.state.requestOrderLines.length <= totalItemPerPage
                    ? 1
                    : Math.ceil(this.state.requestOrderLines.length / totalItemPerPage);
            currentPageItems = this.currentPageItems(activePage, totalItemPerPage, this.state.requestOrderLines);
        }
        this.setState({ pageCount, totalItemPerPage, activePage, currentPageItems });
    };
    private currentPageItems = (activePage: number, totalItemPerPage: number, requestOrderLines: any) => {
        const getEndOrderIndexInPage = activePage * totalItemPerPage - 1;
        let getStartOrderIndexInPage = getEndOrderIndexInPage - totalItemPerPage + 1;
        const currentPageItems: any = [];
        if (getEndOrderIndexInPage && getEndOrderIndexInPage) {
            for (getStartOrderIndexInPage; getStartOrderIndexInPage <= getEndOrderIndexInPage; getStartOrderIndexInPage++) {
                if (requestOrderLines[getStartOrderIndexInPage]) {
                    currentPageItems.push(requestOrderLines[getStartOrderIndexInPage]);
                }
            }
        }
        return currentPageItems;
    };
    public removeOrderRequestLine = async () => {
        if (!this.selectedLine.RequestOrderId) {
            return;
        }
        const customerInfo = this.props.data.customerInformation.result;
        if (customerInfo) {
            await updateRequestOrderAsync(
                { callerContext: this.props.context.actionContext, queryResultSettings: {} },
                this.selectedLine.RequestOrderId,
                this.selectedLine.LineNum,
                2
            ).then(response => {
                this.toggleSnackBar('success', 'Removed Item from Order Request Lines...');
                let requestOrderLines: any = this.state.requestOrderLines;
                requestOrderLines = requestOrderLines.filter((line: any) => {
                    return !(line.RequestOrderId === this.selectedLine.RequestOrderId && line.LineNum === this.selectedLine.LineNum);
                });
                this.togglePopUp(false);
                let currentPageItems = this.state.currentPageItems;
                let activePage = this.state.activePage;
                let pageCount = this.state.pageCount;
                if (requestOrderLines.length === 0) {
                    this.setState({ requestOrderLines, currentPageItems: [], activePage: 1, pageCount: 0 });
                } else {
                    currentPageItems = this.currentPageItems(activePage, this.state.totalItemPerPage, requestOrderLines);
                    pageCount =
                        requestOrderLines.length <= this.state.totalItemPerPage
                            ? 1
                            : Math.ceil(requestOrderLines.length / this.state.totalItemPerPage);
                    if (currentPageItems.length === 0) {
                        if (pageCount > this.state.activePage) {
                            activePage = activePage + 1;
                            currentPageItems = this.currentPageItems(activePage, this.state.totalItemPerPage, requestOrderLines);
                            this.setState({ requestOrderLines, currentPageItems, pageCount });
                        } else {
                            activePage = activePage - 1;
                            currentPageItems = this.currentPageItems(activePage, this.state.totalItemPerPage, requestOrderLines);
                            this.setState({ requestOrderLines, currentPageItems, pageCount, activePage });
                        }
                    } else {
                        this.setState({ requestOrderLines, currentPageItems, pageCount });
                    }
                }
            });
        }
    };

    private readonly _addItemToCart = (requestOrderLine: any) => {
        const { context } = this.props;
        // const { cart } = data;
        const product = requestOrderLine.product.ProductDetails;
        if (context) {
            if (this.state.cart) {
                // generate order reference...
                const weekday = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

                const d = new Date();
                const day = weekday[d.getDay()];
                const year = new Date()
                    .getFullYear()
                    .toString()
                    .substr(-2);
                const oneDigitRandomNumber = Math.floor(1 + Math.random() * 9);
                const fourDigitRandomNumber = Math.floor(1000 + Math.random() * 9000);
                // eslint-disable-next-line radix
                let priceInFloat = parseInt(requestOrderLine.B2BPrice).toString();
                priceInFloat = priceInFloat.padStart(4, '0');
                const referenceNumber = `${day}${year}-${oneDigitRandomNumber}${priceInFloat}-${fourDigitRandomNumber}`;
                const addCartLines = {
                    CatalogId: context.request.apiSettings.catalogId,
                    Description: product.Description,
                    EntryMethodTypeValue: 3,
                    ItemId: product.ItemId,
                    ProductId: product.RecordId,
                    Quantity: requestOrderLine.Quantity,
                    IsPriceKeyedIn: true,
                    TrackingId: '',
                    UnitOfMeasureSymbol: product.DefaultUnitOfMeasure,
                    IsGiftCardLine: false,
                    Price: requestOrderLine.B2CPrice,
                    ExtensionProperties: [
                        {
                            Key: 'AAA_SNAPSHOTID',
                            Value: {
                                StringValue: requestOrderLine.Snapshotid
                            }
                        },
                        {
                            Key: 'AAA_REQUESTORDERID',
                            Value: {
                                StringValue: requestOrderLine.RequestOrderId
                            }
                        },
                        {
                            Key: 'AAA_REQUESTORDERLINENUM',
                            Value: {
                                DecimalValue: requestOrderLine.LineNum
                            }
                        },
                        {
                            Key: 'AAA_REFERENCENUMBER',
                            Value: {
                                StringValue: referenceNumber
                            }
                        }
                    ]
                };
                if (!requestOrderLine.Snapshotid) {
                    addCartLines.IsPriceKeyedIn = false;
                }
                addCartLinesAsync(
                    { callerContext: context.actionContext, queryResultSettings: {} },
                    this.state.cart.Id,
                    [addCartLines],
                    this.state.cart.Version
                )
                    .then(async response => {
                        this.toggleSnackBar('success', 'Item Added to Cart...');
                        this.setState({ cart: response });
                        const cartState = await getCartState(this.props.context.actionContext);
                        await cartState.refreshCart({});
                        this.mappedRequestOrder(this.state.requestOrderLines, this.state.products, this.state.customerInfo, response);
                    })
                    .catch(err => {
                        this.toggleSnackBar('error', 'Add Cart failed');
                    });
            }
        }
    };
    private _renderPopUp = () => {
        const orderConfirmPopHeader: string = this.props.config.cancelPopUpHeading ? this.props.config.cancelPopUpHeading : '';
        const orderConfirmPopContent: string = this.props.config.cancelPopUpContent ? this.props.config.cancelPopUpContent : ``;
        return (
            <div
                id='popup1'
                style={{
                    position: 'fixed',
                    top: '50px !important',
                    left: 0,
                    right: 0,
                    visibility: 'visible',
                    opacity: 1,
                    zIndex: 9
                }}
            >
                <div
                    style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        background: '#fff',
                        border: '1px solid #d2d0d0',
                        width: '30%',
                        position: 'relative',
                        transition: 'all 5s ease-in-out',
                        boxShadow: '5px 8px 5px 2px #888888'
                    }}
                >
                    <div style={{ background: '#f8f8f8', borderBottom: '1px solid #d2d0d0', padding: 22 }}>
                        <h2 style={{ textAlign: 'center', marginLeft: 10 }}>{orderConfirmPopHeader}</h2>
                        <a
                            onClick={() => {
                                this.togglePopUp(false);
                            }}
                            style={{
                                position: 'absolute',
                                top: '20px',
                                right: '30px',
                                transition: 'all 200ms',
                                fontSize: '30px',
                                fontWeight: 'bold',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                color: '#333'
                            }}
                        >
                            &times;
                        </a>
                    </div>
                    <div style={{ maxHeight: '30%', padding: 10, overflow: 'auto', textAlign: 'center' }}> {orderConfirmPopContent}</div>
                    <div style={{ maxHeight: '30%', padding: 10, overflow: 'auto', textAlign: 'center' }}>
                        <Button
                            className='ms-wishlist-items__product-add-button'
                            title={'YES,REMOVE'}
                            style={{ marginBottom: '5px', marginLeft: '5px', cursor: 'pointer' }}
                            onClick={() => this.removeOrderRequestLine()}
                        >
                            {'YES,REMOVE'}
                        </Button>
                        <Button
                            className='ms-wishlist-items__product-add-button'
                            title={'NO'}
                            style={{ marginBottom: '5px', marginLeft: '5px', cursor: 'pointer' }}
                            onClick={() => this.togglePopUp(false)}
                        >
                            {'NO'}
                        </Button>
                    </div>
                </div>
            </div>
        );
    };
    private togglePopUp = (visible: boolean, line?: any) => {
        const removePopUpVisible: any = visible;
        if (removePopUpVisible) {
            this.selectedLine = line;
        } else {
            this.selectedLine = '';
        }
        this.setState({ removePopUp: { visible: removePopUpVisible } });
    };
    public toggleSnackBar = (type: string, message: string) => {
        const toasterInfo = { visible: true, type: type, message: message };
        this.setState({ toasterInfo });
        // After 3 seconds, remove the show class from DIV
        setTimeout(() => {
            const toasterInfo = { visible: false, type: '', message: '' };
            this.setState({ toasterInfo });
        }, 3000);
    };
    private handleOnChangeInput = (searchString: string) => {
        this.setState({ searchString: searchString.toLowerCase() });
    };
    private searchItems = () => {
        if (this.state.searchString) {
            const searchPageItems: any = this.state.requestOrderLines.filter((f: any) => {
                return f.b2CCustomerName.toLowerCase().includes(this.state.searchString);
            });
            console.log(searchPageItems);
            const currentPageItems = this.currentPageItems(1, this.state.totalItemPerPage, searchPageItems);
            this.setState({
                activePage: 1,
                searchPageItems,
                currentPageItems: currentPageItems,
                pageCount:
                    searchPageItems.length <= this.state.totalItemPerPage
                        ? 1
                        : Math.ceil(searchPageItems.length / this.state.totalItemPerPage)
            });
        }
    };
    private resetItems = () => {
        const currentPageItems = this.currentPageItems(1, this.state.totalItemPerPage, this.state.requestOrderLines);
        this.setState({
            searchPageItems: [],
            searchString: '',
            currentPageItems,
            activePage: this.state.activePage,
            pageCount:
                this.state.requestOrderLines.length <= this.state.totalItemPerPage
                    ? 1
                    : Math.ceil(this.state.requestOrderLines.length / this.state.totalItemPerPage)
        });
    };
    public render(): JSX.Element | null {
        if (!this.state.customerInfo) {
            return null;
        }

        const viewProps: IOrderRequestlinesTemplateViewProps = {
            ...(this.props as IOrderRequestlinesTemplateProps<IOrderRequestlinesTemplateData>),
            requestOrderLines: this.state.requestOrderLines,
            toasterInfo: this.state.toasterInfo,
            removePopUp: this.state.removePopUp,
            addItemToCart: this._addItemToCart,
            headers: this.state.headers,
            removeOrderRequestLine: this.removeOrderRequestLine,
            _renderPopUp: this._renderPopUp,
            _togglePopUp: this.togglePopUp,
            activePage: this.state.activePage,
            totalItemPerPage: this.state.totalItemPerPage,
            currentPageItems: this.state.currentPageItems,
            pageCount: this.state.pageCount,
            handlePageItemsChange: this.handlePageItemsChange,
            handleMouseEnterEvent: this.handleMouseEnterEvent,
            handleMouseOutEvent: this.handleMouseOutEvent,
            mouseOverIndex: this.state.mouseOverIndex,
            handleOnChangeInput: this.handleOnChangeInput,
            searchItems: this.searchItems,
            resetItems: this.resetItems,
            searchString: this.state.searchString,
            searchPageItems: this.state.searchPageItems,
            isLoading: this.state.isLoading,
            getOrderDetailPageUrl: this.getOrderDetailPageUrl
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default OrderRequestlinesTemplate;
